// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sx87","colBig":"styles_colBig__1wp4k","colSmall":"styles_colSmall__3Kb0L"};